<div class="journeyHeader skip-formlib-override">
    <h3>{{ title }}</h3>
    <div class="journeyProgress">
        <span 
            aria-hidden="true"
            class="statusDotConnector"
        ></span>
        <ng-content></ng-content>
    </div>
</div>